import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
export class SelectOptionModel extends CoreModel {
/**
 * Option object
 */
option?: any;
/**
 * Option value
 */
value?: any;
/**
 * Option property name to be used as option value
 */
optionValueField?: string;
/**
 * Option label
 */
label?: any;
/**
 * Option property name to be used as select text when option is selected and as option text if item property is not specified
 */
optionLabelField?: string;
/**
 * Option item
 */
item?: any;
/**
 * Option property name to be used as option item
 */
optionItemField?: string;
/**
 * Option icon
 */
icon?: IconModel;
/**
 * Option property name to be used as option icon
 */
optionIconField?: string;
/**
 * @hidden 
 * It is icon constructor, which take values from component and create model object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function SelectOptionModel_tsickle_Closure_declarations() {
/**
 * Option object
 * @type {?}
 */
SelectOptionModel.prototype.option;
/**
 * Option value
 * @type {?}
 */
SelectOptionModel.prototype.value;
/**
 * Option property name to be used as option value
 * @type {?}
 */
SelectOptionModel.prototype.optionValueField;
/**
 * Option label
 * @type {?}
 */
SelectOptionModel.prototype.label;
/**
 * Option property name to be used as select text when option is selected and as option text if item property is not specified
 * @type {?}
 */
SelectOptionModel.prototype.optionLabelField;
/**
 * Option item
 * @type {?}
 */
SelectOptionModel.prototype.item;
/**
 * Option property name to be used as option item
 * @type {?}
 */
SelectOptionModel.prototype.optionItemField;
/**
 * Option icon
 * @type {?}
 */
SelectOptionModel.prototype.icon;
/**
 * Option property name to be used as option icon
 * @type {?}
 */
SelectOptionModel.prototype.optionIconField;
}

